var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gallery-wrapper gallery-wrapper-video" },
    [
      _c("div", { staticClass: "gallery-category" }, [
        _c(
          "div",
          { staticClass: "category-tree category-tree-myGallery" },
          [
            _c(
              "el-scrollbar",
              {
                attrs: {
                  wrapStyle:
                    "height:550px;overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;",
                },
              },
              [
                _c("el-tree", {
                  key: "treeVideo",
                  ref: "treeVideo",
                  attrs: {
                    "empty-text": "",
                    data: _vm.videoDirList,
                    props: { children: "_child", label: "name" },
                    "node-key": "id",
                    "default-expanded-keys": _vm.defaultExpandedkeys,
                    indent: 10,
                    "highlight-current": "",
                  },
                  on: { "node-click": _vm.clickVideoDir },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var node = ref.node
                        var data = ref.data
                        return _c("span", { staticClass: "custom-tree-node" }, [
                          _c(
                            "span",
                            {
                              staticClass: "tree-item-node-name",
                              class: { "tree-node-child": data.id > 0 },
                              attrs: { title: data.name },
                            },
                            [
                              _c("span", { staticClass: "tree-item-name" }, [
                                _vm._v(_vm._s(data.name)),
                              ]),
                              _c("span", { staticClass: "image-num" }, [
                                _vm._v(_vm._s(data.count)),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "more-operations",
                              class: { "is-show-add": data.id == 0 },
                            },
                            [
                              _c(
                                "span",
                                [
                                  data.id > 0
                                    ? _c(
                                        "el-dropdown",
                                        {
                                          attrs: { trigger: "hover" },
                                          on: { command: _vm.handleCommand },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-more delete-edit-operations",
                                          }),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    command: {
                                                      type: "delete",
                                                      node: node,
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    command: {
                                                      type: "rechristen",
                                                      node: node,
                                                    },
                                                  },
                                                },
                                                [_vm._v("重命名")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                [
                                  data.level < 1
                                    ? _c(
                                        "el-dropdown",
                                        {
                                          attrs: { trigger: "hover" },
                                          on: { command: _vm.handleCommand },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-plus add-operations",
                                          }),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    command: {
                                                      type: "add",
                                                      node: node,
                                                    },
                                                  },
                                                },
                                                [_vm._v("新建")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "gallery-main" }, [
        _c("div", { staticClass: "pictureNew-tit" }, [
          _c(
            "div",
            { staticClass: "searchImg" },
            [
              _c("el-input", {
                staticClass: "search-img",
                attrs: {
                  clearable: "",
                  placeholder: "请输入文件名称",
                  "prefix-icon": "el-icon-search",
                },
                on: {
                  input: _vm.searchVideoResult,
                  clear: _vm.emptyVideoSearchResults,
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchVideo($event)
                  },
                },
                model: {
                  value: _vm.videoName,
                  callback: function ($$v) {
                    _vm.videoName = $$v
                  },
                  expression: "videoName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pictureNew-category-add" },
            [
              _c(
                "el-select",
                {
                  staticClass:
                    "batch-perationData qm-upload__batch-perationData",
                  attrs: { placeholder: "上传音视频" },
                  on: { change: _vm.uploadVideo },
                  model: {
                    value: _vm.uploadVideoValue,
                    callback: function ($$v) {
                      _vm.uploadVideoValue = $$v
                    },
                    expression: "uploadVideoValue",
                  },
                },
                _vm._l(_vm.uploadVideoList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "batch-perationData",
                  attrs: { placeholder: "批量操作" },
                  model: {
                    value: _vm.batchPeration,
                    callback: function ($$v) {
                      _vm.batchPeration = $$v
                    },
                    expression: "batchPeration",
                  },
                },
                _vm._l(_vm.batchPerationData, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "image-wrapper" }, [
          _c("div", { staticClass: "image-list-main" }, [
            _c(
              "div",
              { staticClass: "image-list-item" },
              [
                _c("div", { staticClass: "image-operation-panel" }, [
                  _vm.batchPeration
                    ? _c(
                        "div",
                        { staticClass: "select-images-num" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkAll",
                              attrs: {
                                size: "mini",
                                indeterminate: _vm.isIndeterminate,
                              },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [
                              _vm._v(
                                "\n                全选\n                "
                              ),
                              _vm.selectVideo.length > 0
                                ? _c("span", [
                                    _vm._v("已选中\n                  "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "image-operation-panel_num",
                                      },
                                      [_vm._v(_vm._s(_vm.selectVideo.length))]
                                    ),
                                    _vm._v("\n                  个"),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm.batchPeration == 1
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "delete-picture",
                                  attrs: {
                                    type: "text",
                                    size: "mini",
                                    disabled: !_vm.selectVideo.length,
                                  },
                                  on: { click: _vm.deleteSelectVideo },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "right",
                                width: "300",
                                trigger: "click",
                              },
                              model: {
                                value: _vm.moveTreevisible,
                                callback: function ($$v) {
                                  _vm.moveTreevisible = $$v
                                },
                                expression: "moveTreevisible",
                              },
                            },
                            [
                              _c("el-tree", {
                                ref: "treeMovePic",
                                attrs: {
                                  "empty-text": "",
                                  data: _vm.videoDirList,
                                  props: { children: "_child", label: "name" },
                                  "node-key": "id",
                                  "default-expanded-keys": [0],
                                  "expand-on-click-node": false,
                                  indent: 10,
                                  "highlight-current": "",
                                },
                                on: { "node-click": _vm.moveVideoToTree },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return _c(
                                        "span",
                                        { staticClass: "custom-tree-node" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tree-item-node-name",
                                              class: {
                                                "tree-node-child": data.id != 0,
                                              },
                                              attrs: { title: data.name },
                                            },
                                            [_vm._v(_vm._s(data.name))]
                                          ),
                                        ]
                                      )
                                    },
                                  },
                                ]),
                              }),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.batchPeration == 2,
                                      expression: "batchPeration == 2",
                                    },
                                  ],
                                  staticClass: "delete-picture",
                                  attrs: {
                                    slot: "reference",
                                    disabled: !_vm.selectVideo.length,
                                    type: "text",
                                    size: "mini",
                                  },
                                  slot: "reference",
                                },
                                [_vm._v("移动\n                ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "cancel-delete-picture",
                              attrs: { type: "text", size: "mini" },
                              on: { click: _vm.cancelBatchOperations },
                            },
                            [_vm._v("取消")]
                          ),
                        ],
                        1
                      )
                    : _c("span", [
                        _vm._v("已选中"),
                        _c(
                          "span",
                          { staticClass: "image-operation-panel_num" },
                          [_vm._v(_vm._s(_vm.selectVideo.length))]
                        ),
                        _vm._v("个"),
                      ]),
                ]),
                _c(
                  "el-scrollbar",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.videoLoading,
                        expression: "videoLoading",
                      },
                    ],
                    staticStyle: { height: "calc(100% - 36px)" },
                    attrs: {
                      wrapStyle:
                        "overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "image-list" },
                      _vm._l(_vm.videoData.data, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: "video+" + index,
                            staticClass: "image-item qm-upload-video_item",
                            class: { active: _vm.checkboxStatus(item.id) },
                            on: {
                              click: function ($event) {
                                _vm.viewVideoDetail(item)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "image-item-main",
                                class: {
                                  "batch-peration-show-btn": !_vm.batchPeration,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.imageCheckboxChange(item)
                                  },
                                },
                              },
                              [
                                item.coverUrl
                                  ? _c("img", {
                                      staticClass: "qm-upload-video_image",
                                      attrs: {
                                        draggable: "false",
                                        src: item.coverUrl,
                                      },
                                    })
                                  : _c("img", {
                                      staticClass: "qm-upload-video_image",
                                      attrs: {
                                        draggable: "false",
                                        src: "https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png",
                                        alt: "",
                                      },
                                    }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "image-title-bg image-title-show",
                                  },
                                  [
                                    _c("span", { staticClass: "image-name" }, [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(item.name) +
                                          "\n                    "
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "image-title-bg image-download-magnify-delete",
                                  },
                                  [
                                    _c("i"),
                                    _c("span", [
                                      _c("i", {
                                        staticClass: "qm-icon-download",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.downVideo(item)
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "qm-icon-delete",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.deleteVideo(item)
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                                _vm.checkboxStatus(item.id)
                                  ? _c("span", { staticClass: "state-check" }, [
                                      _c("i", { staticClass: "el-icon-check" }),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "image-operation-page" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.videoData.pageIndex,
                    "page-sizes": [20, 40, 60],
                    "page-size": _vm.videoData.pageSize,
                    layout: "prev, pager, next,sizes",
                    total: _vm.videoData.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.paginationChange,
                    "update:currentPage": function ($event) {
                      _vm.$set(_vm.videoData, "pageIndex", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "image-detail-wrapper qm-upload__detail-wrapper" },
            [
              _c("pictorial-information", {
                attrs: {
                  imageInfo: _vm.videoInfo,
                  isShowMoreImage: _vm.isShowMoreImage,
                  selectImages: _vm.selectVideo,
                  galleryType: 1,
                  galleryShowType: 2,
                },
                on: { saveVideoInfo: _vm.saveVideoInfo },
              }),
              !_vm.batchPeration
                ? _c(
                    "div",
                    { staticClass: "gallery-control-wrapper" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.selectVideo.length,
                          },
                          on: { click: _vm.submitSelectVideo },
                        },
                        [_vm._v("插入")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c("UploadVideoPop", {
        ref: "uploadVideoPop",
        attrs: {
          uploadType: _vm.uploadType,
          currentVideoDir: _vm.currentVideoDir,
        },
        on: {
          videoUploadedSuccess: _vm.videoUploadedSuccess,
          closeUploadDialog: _vm.closeUploadDialog,
        },
      }),
      _c("deltree-pop", {
        ref: "deltreePop",
        attrs: { delType: 2 },
        on: { delTargetItem: _vm.delCategory },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }